module.exports = __webpack_public_path__ + "img/hotel3.81765cc4.png";